const CardCheckBox = ({ checked, disabled }) => {
  const getColor = () => {
    let color;
    if (disabled) {
      color = "#4E4E4E";
    } else {
      color = checked ? "#FA9600" : "#E9E9E9";
    }
    return color;
  };

  const checkPath = (
    <path
      id="Icon_feather-check"
      data-name="Icon feather-check"
      d="M25.582,9,12.12,22.463,6,16.343"
      transform="translate(9 9)"
      fill="none"
      stroke={getColor()}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  );

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48.395" height="48.395" viewBox="0 0 48.395 48.395">
      <g id="Tracé_11577" data-name="Tracé 11577" fill="none">
        <path d="M24.2,0A24.2,24.2,0,1,1,0,24.2,24.2,24.2,0,0,1,24.2,0Z" stroke="none" />
        <path
          d="M 24.19732666015625 1.999996185302734 C 21.19982719421387 1.999996185302734 18.29304695129395 2.586616516113281 15.55773544311523 3.743545532226562 C 12.91473770141602 4.861446380615234 10.54065704345703 6.462238311767578 8.501445770263672 8.501445770263672 C 6.462238311767578 10.54065704345703 4.861446380615234 12.91473770141602 3.743545532226562 15.55773544311523 C 2.586616516113281 18.29304695129395 1.999996185302734 21.19982719421387 1.999996185302734 24.19732666015625 C 1.999996185302734 27.19482612609863 2.586616516113281 30.10160636901855 3.743545532226562 32.83691787719727 C 4.861446380615234 35.47991561889648 6.462238311767578 37.85399627685547 8.501445770263672 39.89320755004883 C 10.54065704345703 41.93241500854492 12.91473770141602 43.53320693969727 15.55773544311523 44.65109634399414 C 18.29304695129395 45.80803680419922 21.19982719421387 46.39465713500977 24.19732666015625 46.39465713500977 C 27.19482612609863 46.39465713500977 30.10160636901855 45.80803680419922 32.83691787719727 44.65109634399414 C 35.47991561889648 43.53320693969727 37.85399627685547 41.93241500854492 39.89320755004883 39.89320755004883 C 41.93241500854492 37.85399627685547 43.53320693969727 35.47991561889648 44.65109634399414 32.83691787719727 C 45.80803680419922 30.10160636901855 46.39465713500977 27.19482612609863 46.39465713500977 24.19732666015625 C 46.39465713500977 21.19982719421387 45.80803680419922 18.29304695129395 44.65109634399414 15.55773544311523 C 43.53320693969727 12.91473770141602 41.93241500854492 10.54065704345703 39.89320755004883 8.501445770263672 C 37.85399627685547 6.462238311767578 35.47991561889648 4.861446380615234 32.83691787719727 3.743545532226562 C 30.10160636901855 2.586616516113281 27.19482612609863 1.999996185302734 24.19732666015625 1.999996185302734 M 24.19732666015625 -3.814697265625e-06 C 37.56113433837891 -3.814697265625e-06 48.39465713500977 10.8335075378418 48.39465713500977 24.19732666015625 C 48.39465713500977 37.56113433837891 37.56113433837891 48.39465713500977 24.19732666015625 48.39465713500977 C 10.8335075378418 48.39465713500977 -3.814697265625e-06 37.56113433837891 -3.814697265625e-06 24.19732666015625 C -3.814697265625e-06 10.8335075378418 10.8335075378418 -3.814697265625e-06 24.19732666015625 -3.814697265625e-06 Z"
          stroke="none"
          fill={getColor()}
        />
      </g>
      {checked && checkPath}
    </svg>
  );
};

export default CardCheckBox;
